var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartBorder = function SvgHeartBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2313 3.49825C13.4213 3.72037 13.6989 3.84824 13.9912 3.84824C14.2835 3.84824 14.5611 3.72037 14.7511 3.49826C17.1151 0.73456 20.887 0.0923342 23.8033 2.51622C26.7753 4.98639 27.1406 9.1739 24.8402 12.1341C23.8045 13.4668 21.6659 15.5972 19.4648 17.6747C17.2829 19.7342 15.101 21.6849 14.0229 22.6396C14.0119 22.6494 14.0013 22.6588 13.9912 22.6677C13.9811 22.6588 13.9705 22.6494 13.9594 22.6396C12.8814 21.6849 10.6995 19.7342 8.51758 17.6747C6.31648 15.5972 4.17789 13.4668 3.14219 12.1341C0.850606 9.18527 1.25119 5.01802 4.18952 2.50745C7.03813 0.0735363 10.8598 0.72575 13.2313 3.49825Z",
    fill: "currentColor",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeartBorder;